import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation, useQueryClient } from 'react-query';
import { addFlexMatchRequest } from 'RestAPIs/flex-match';
import { AddFlexMatchRequestPayload } from 'RestAPIs/flex-match/types';

const useAddFlexMatchRequest = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: AddFlexMatchRequestPayload) => addFlexMatchRequest(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('flexMatchTasks');
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useAddFlexMatchRequest;
